module.exports = __webpack_public_path__ + "static/img/wanted2.1e8c4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted2.png
// module id = uMPl
// module chunks = 1 3